import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FormattedMessage } from "react-intl";

import BaseFormCard from "../../base/BaseFormCard";
import ArrowForwardIcon from "../../../assets/icons/ArrowForwardIcon";
import {
  CARD_PAPER_STYLE,
  CARD_PAPER_SX,
  CARD_HEADER_SX,
  CARD_TITLE_SX,
  CARD_BODY_SX,
  CARD_DATE_SX,
  CARD_ARROW_SX
} from "./subscribed-item";

export default function PendingItem({
  nameKey,
  descriptionKey,
  redirectUrl,
  itemId
}) {
  const handleClick = () => {
    if (redirectUrl) {
      window.open(redirectUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <BaseFormCard
      noForm
      headerBorder={false}
      title={nameKey}
      titleColor="var(--font-strong-warning)"
      titleProps={{
        sx: CARD_TITLE_SX,
        "data-testid": `pending-item-${itemId}-name`
      }}
      paperStyle={{
        ...CARD_PAPER_STYLE,
        backgroundColor: "var(--alert-background-warning)"
      }}
      paperSx={CARD_PAPER_SX}
      headerSx={CARD_HEADER_SX}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      data-testid={`pending-item-${itemId}`}
    >
      <Box sx={CARD_BODY_SX}>
        <Typography
          data-testid={`pending-item-${itemId}-description`}
          component="p"
          sx={{ ...CARD_DATE_SX, m: 0, color: "var(--font-strong-warning)" }}
        >
          <FormattedMessage id={descriptionKey} defaultMessage={descriptionKey} />
        </Typography>
      </Box>
      <Box sx={CARD_ARROW_SX} data-testid={`pending-item-${itemId}-arrow`}>
        <ArrowForwardIcon color="var(--font-strong-warning)" />
      </Box>
    </BaseFormCard>
  );
}
